<template>
    <div>
        <list-item
            v-for="job in jobList"
            class="row align-items-center position-relative search-result"
            :job="job"
            :key="job.job_id"
        >
        </list-item>
    </div>
</template>

<script lang="ts" setup>
import {inject} from "vue";
import type JobApiProvider from "../JobApiProvider.ts";
import {KeyJobApiProvider} from "../symbols.ts";
import ListItem from "./ListItem.vue";

const provider = inject<JobApiProvider>(KeyJobApiProvider) as JobApiProvider;

const jobList = provider.jobList();
</script>



